import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import './Infographic.scss';
import { ReactComponent as House } from './house.svg';

function Infographic() {
  const houseRef = useRef();
  const top = useRef();
  const bottom = useRef();
  useEffect(() => {
    const setTOrigin = gsap.quickSetter('.infographic__graphic__icon-house', 'transformOrigin');
    let tl = gsap.timeline({
      once: true,
      ease: 'linear',
      scrollTrigger: {
        trigger: houseRef.current,
        start: 'top 80%',
        end: 'top 30%',
        scrub: 1
      }
    });
    tl.to('.infographic__graphic__icon', {
      scrollTrigger: houseRef.current,
      scale: 1,
      duration: 0.7,
      onUpdate: () => setTOrigin('50% 100%')
    })
      .to('.infographic__graphic__icon-red', { opacity: 1, duration: 0.3 }, '>')
      .to(top.current, { opacity: 1, duration: 0.3 }, '<')
      .to('.infographic__graphic__icon-house', {
        fill: '#004282',
        duration: 0.5
      })
      .to(bottom.current, { opacity: 1, duration: 0.5 }, '<');
  }, []);

  return (
    <figure className="infographic">
      <div className="infographic__graphic">
        <h3 className="infographic__graphic__title">
          The median u.s. homeowner
          <br /> gained <span className="infographic__graphic__title--red">$240,000</span> in equity
          <br /> from 2012 to 2022
        </h3>

        <House ref={houseRef} />
        <div className="infographic__graphic__key infographic__graphic__key-top" ref={top}>
          <svg
            className="infographic__graphic__key__color"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="25"
              height="25"
              fill="#E35505"
              className="infographic__graphic__key__color__rect--top"
            />
          </svg>
          <span className="infographic__graphic__key__copy">
            $31,000 mortgage principal reduction
          </span>
        </div>
        <div className="infographic__graphic__key infographic__graphic__key-bottom" ref={bottom}>
          <svg
            className="infographic__graphic__key__color"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="25"
              height="25"
              fill="#E35505"
              className="infographic__graphic__key__color__rect"
            />
          </svg>
          <span className="infographic__graphic__key__copy">
            $209,000 equity built through price gains
          </span>
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Infographic;
